<template>
    <div class="nav-main" v-if="setup != 0">
        <ul class="list-unstyled nav">
           <li v-for="(nav,index) in setup.main_page_navigation.slice(0, 2)">    
                <a :href="'#section-' + nav.href" 
                    v-scroll-to="{
                        el: '#section-' + nav.href,
                        offset: -75
                    }"
                    @click.prevent="closeMenu(!isOpenSendwich)"
                >
                    {{nav.name}}
                </a>
            </li>
            <li v-for="(nav,index) in setup.main_page_navigation.slice(2, 10)">
                <a :href="'#section-' + nav.href" 
                    v-scroll-to="{
                        el: '#section-' + nav.href,
                        offset: -74
                    }"
                    @click.prevent="closeMenu(!isOpenSendwich)"
                >
                    {{nav.name}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'nav-main',
        data () {
            return {
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            isOpenSendwich: 'loadIsOpenSendwich',
        }),
        methods: {
            closeMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // if (data === true) {
                //     document.getElementById('secret-btns').classList.remove('fadeIn');
                // } else {
                //     if (window.scrollY >= window.innerHeight) {
                //         document.getElementById('secret-btns').classList.add('fadeIn');
                //     }
                // }
            },
            // disableOverlay() {
            //     this.$store.commit('Open_Sendwich', false);
            //     document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            // }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/nav-main.scss';
    @import '@/styles/components/nav-main/respond-nav-main.scss';
</style>